module.exports = __webpack_public_path__ + "static/img/om.083160ec.svg";